import { App, Button, Flex, Form, Select, Typography } from "antd"
import { PushRole, useAuth } from "../hooks/useAuth";
import { Audience, Campaign, CreateAudience, PushActionType } from "../interfaces/Campaign.interface";
import { AudienceCreator } from "./AudienceCreator";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import FormItem from "antd/es/form/FormItem";
import { tagRender } from "./InputHelpers/Tag.helper"
import { audienceQueryToSelectOptions } from "./InputHelpers/AudienceSeleciton.helper";
import { RecieverApp } from "./PushReciever/RecieverApp";
import { Mode } from "../interfaces/mode.type";
import { DefaultOptionType } from "antd/es/select";

export const CampaignDevTools = (props: { applicationId: string, apiKey:string, onSaveCampaign:(campaign:Campaign)=>Promise<boolean>})=>{
    const auth = useAuth();
    const { message } = App.useApp();
    const [form] = Form.useForm<Campaign>();
    const queryClient = useQueryClient();
    const audienceQuery = useQuery({ queryKey: ['audience', props.applicationId], queryFn: () => auth.api.getAudiences(props.applicationId) })

    const audienceMutation = useMutation({
        mutationFn: async (audience: CreateAudience) => await auth.api.createAudience(props.applicationId, audience),
        onSuccess: () => {
            // Invalidate and refetch
            queryClient.invalidateQueries({ queryKey: ['audience', props.applicationId] })
        },
        onError: () => {
            console.error("Oops we failed to create an Audience")
            message.error("Oops we failed to create an Audience");
        }
    })
    
    const executeTestCase = (testCaseId:string) => {
        let newCampaign:Campaign|null = null;

        let audiences:string[] = form.getFieldValue("audiences");
        if(!audiences || audiences.length == 0)
        {
            message.error("Can't send push without an audience set");
            return
        }
        switch(testCaseId)
        {
            case "TC1":
                newCampaign = {
                    name: "TC1 Silent Push",
                    pushMessage: {
                        title: "Silent Push Title",
                        message: "Silent Push Message",
                        actions: [],
                        isSilent: true
                    },
                    audiences:audiences,
                    deliverAt: new Date(),
                    isTestCampaign: true,
                    meta: {
                        "type":"test-case-1",
                        "source":"admin-app"
                    },
                    hidden: true
                }
                break;
            case "TC2":
                newCampaign = {
                    name: "TC2 Category Notification Watch Dismiss",
                    pushMessage: {
                        title: "New Episode!",
                        message: "Race across the world",
                        actions: [
                            {
                                type: PushActionType.open,
                                url: "https://mediahq-app.switch.tv/web-demo-uat/#/shows/the_race"
                            },
                            {
                                type: PushActionType.watch,
                                url: "https://mediahq-app.switch.tv/web-demo-uat/#/shows/the_race/play"
                            }
                        ],
                        isSilent: false
                    },
                    audiences: audiences,
                    deliverAt: new Date(),
                    isTestCampaign: true,
                    meta: {
                        "type":"test-case-2",
                        "source":"admin-app"
                    },
                    hidden: true
                }
                break;
        }

        if(newCampaign)
        {
            console.log('test-sendcampaign', audiences);
            props.onSaveCampaign(newCampaign);
        }
        
    }

    const createAudience = async (audience:CreateAudience)=>{
        try {
            let newAudience = await audienceMutation.mutateAsync(audience);
            return newAudience;
        } catch (error) {
            // Re-throw the error so it's caught by the AudienceCreator component
            throw error;
        }
    }

    if(auth.hasClaims(props.applicationId, PushRole.CanUseDeveloperTools))
    {
        return (
            <Flex vertical style={{width: '100%'}}>
            
                      
                <h2>Test Application</h2>
                <RecieverApp applicationId={props.applicationId} apiKey={props.apiKey}/>
                      
                <hr />
                <Typography.Title level={4}>Test Case (TC)</Typography.Title>
                <Form
                    form={form}
                    layout={"vertical"}
                >
                <Form.Item label={<Flex align="baseline" gap={5}>
                                <Typography.Text>Audience</Typography.Text>
                                <AudienceCreator operationMode={Mode.New} applicationId={props.applicationId} saveAudience={(audience: CreateAudience) => createAudience(audience)} />
                            </Flex>
                            } name="audiences" getValueFromEvent={(e) => {
                                return e;
                            }}>
                                <Select
                                    mode="multiple"
                                    tagRender={tagRender}
                                    style={{ width: '100%' }}
                                    filterOption={(inputValue: string, option?: DefaultOptionType) => {
                                        return (option?.label ?? "").toString().toLowerCase().includes((inputValue??"").toLowerCase())
                                    }}
                                    options={audienceQueryToSelectOptions(audienceQuery)}
                                />
                            </Form.Item>
                </Form>
                <Flex gap={10} wrap>
                    <Button onClick={()=>executeTestCase("TC1")}>TC1: Send Silent Push</Button>
                    <Button onClick={()=>executeTestCase("TC2")}>TC2: Send Watch + Dismiss</Button>
                </Flex>
            </Flex>
        )
    }
    return (<></>)
    
}